<template>
  <div v-loading.body="loading">
    <header-tabs :active="$route.path"></header-tabs>
    <el-row class="filter">
      <div
        style="
          width: 80%;
          margin: 0 auto;
          margin-top: 20px;
          margin-bottom: 20px;
        "
      >
        <el-form
          ref="form"
          :model="form"
          label-width="160px"
          class="demo-ruleForm"
        >
          <p>包裹点货容错率:(收包数量-包裹点货数量)/收包数量</p>
          <el-form-item label="正负误差(%):" prop="dabiao_error_range">
            <el-input
              v-model="form.dabiao_error_range"
              type="number"
              style="width: 90%"
              ><template slot="append">%</template></el-input
            >
          </el-form-item>
          <p>
            包裹点货报错时长:"今日已收完"的商家包裹,提交批次数量不在容错范围内,超时报错
          </p>
          <el-form-item label="报错时长(分钟)：" prop="dabiao_limit_time">
            <el-input
              v-model="form.dabiao_limit_time"
              type="number"
              style="width: 90%"
              ><template slot="append">分钟</template></el-input
            >
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit">保存</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
        <el-form ref="formQuality" :model="formQuality">
          <el-form-item
            label="拦截客服的疑似次品商品进行质检"
            prop="customer_intercept_defective"
          >
            <el-switch
              v-model="formQuality.customer_intercept_defective"
              active-value="1"
              inactive-value="2"
            ></el-switch>

            <div class="high-value">
              拦截高单价商品进行质检
              <el-switch
                v-model="formQuality.high_value_intercept_defective"
                class="high-value-switch"
                active-value="1"
                inactive-value="2"
              ></el-switch>
            </div>
          </el-form-item>

          <el-form-item
            label="拦截仓库的质检次品率高的商品进行质检"
            prop="storehouse_intercept_defective"
          >
            <el-switch
              v-model="formQuality.storehouse_intercept_defective"
              active-value="1"
              inactive-value="2"
            ></el-switch>
          </el-form-item>

          <el-form-item
            label="新pc点货时绑定防伪扣"
            prop="high_value_bind_safety_buckle"
          >
            <el-switch
              v-model="formQuality.high_value_bind_safety_buckle"
              active-value="1"
              inactive-value="2"
            ></el-switch>
          </el-form-item>

          <el-form-item label-width="160px">
            <el-button type="primary" @click="handleQualitySave">
              保存
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
    <el-row> </el-row>
  </div>
</template>

<script>
import Global_ from "../../components/Global.vue";
import HeaderTabs from "./components/HeaderTabs.vue";
import * as qualityApi from "@/controller/quality2353.js";

export default {
  components: { HeaderTabs },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      form: {},
      loading: false,
      tableLoading: false,
      url: "/erp/WavePicking/DaBiaoSetting",
      filterFold: false,
      supplyData: null,
      origin: Global_.origin,
      formQuality: {
        customer_intercept_defective: "",
        storehouse_intercept_defective: "",
        high_value_bind_safety_buckle: "",
      },
    };
  },
  computed: {
    filteredForm() {
      // eslint-disable-next-line no-restricted-syntax
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    removeShipping(item) {
      const index = this.form.shipping_companies.indexOf(item);
      if (index !== -1) {
        this.form.shipping_companies.splice(index, 1);
      }
    },
    addShipping() {
      this.form.shipping_companies.push({
        key: Date.now(),
        min: 0,
        max: 0,
        shipping_company: "",
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.get(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form = res.data.data;
        }
      });
      qualityApi
        .getDaBiaoIntercept()
        .then((res) => {
          this.formQuality = res;
        })
        .catch(this.$noop);
    },
    onSubmit() {
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$message.success("操作成功");
          this.shipping_company = res.data.data.shipping_company;
        }
      });
    },
    handleQualitySave() {
      qualityApi
        .setDaBiaoIntercept(this.formQuality)
        .then(() => {
          this.$message.success("操作成功");
        })
        .catch(this.$noop);
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
.high-value {
  display: inline-block;
  margin-left: 32px;
  line-height: 1;
}
.high-value-switch {
  margin-left: 8px;
}
</style>



// WEBPACK FOOTER //
// src/pages/wavepicking/DaBiaoSetting.vue